export default __webpack_public_path__ + "static/media/pic4.d03dbfb8.jpg";